var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.08329V3.41663C18.3333 2.16663 17.8 1.66663 16.475 1.66663H13.1083C11.7833 1.66663 11.25 2.16663 11.25 3.41663V9.08329C11.25 10.3333 11.7833 10.8333 13.1083 10.8333H16.475C17.8 10.8333 18.3333 10.3333 18.3333 9.08329Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.5834V15.0834C18.3333 13.8334 17.8 13.3334 16.475 13.3334H13.1083C11.7833 13.3334 11.25 13.8334 11.25 15.0834V16.5834C11.25 17.8334 11.7833 18.3334 13.1083 18.3334H16.475C17.8 18.3334 18.3333 17.8334 18.3333 16.5834Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74996 10.9166V16.5833C8.74996 17.8333 8.21663 18.3333 6.89163 18.3333H3.52496C2.19996 18.3333 1.66663 17.8333 1.66663 16.5833V10.9166C1.66663 9.66663 2.19996 9.16663 3.52496 9.16663H6.89163C8.21663 9.16663 8.74996 9.66663 8.74996 10.9166Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74996 3.41663V4.91663C8.74996 6.16663 8.21663 6.66663 6.89163 6.66663H3.52496C2.19996 6.66663 1.66663 6.16663 1.66663 4.91663V3.41663C1.66663 2.16663 2.19996 1.66663 3.52496 1.66663H6.89163C8.21663 1.66663 8.74996 2.16663 8.74996 3.41663Z",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDevice);
export default __webpack_public_path__ + "static/media/dashboard-device.d57438eeb130ddc53944a6646394d612.svg";
export { ForwardRef as ReactComponent };